import type { Dispatch } from "@reduxjs/toolkit";

export const ADD_TICKET_NOTE_TEMP = "ADD_TICKET_NOTE_TEMP";
export const ADMIN_UPDATE_USER = "ADMIN_UPDATE_USER";
export const ADMIN_UPDATE_USER_SUCCESS = "ADMIN_UPDATE_USER_SUCCESS";
export const ADMIN_UPDATE_USER_ERROR = "ADMIN_UPDATE_USER_ERROR";

export const ADMIN_CREATE_USER = "ADMIN_CREATE_USER";
export const ADMIN_CREATE_USER_SUCCESS = "ADMIN_CREATE_USER_SUCCESS";
export const ADMIN_CREATE_USER_ERROR = "ADMIN_CREATE_USER_ERROR";

export const ADMIN_RESET_USER_STATUS = "ADMIN_RESET_USER_STATUS";

export const ADMIN_MANUAL_EMAIL_APPROVAL = "ADMIN_UPDATE_MANUAL_EMAIL_APPROVAL";
export const ADMIN_MANUAL_EMAIL_APPROVAL_SUCCESS =
  "ADMIN_MANUAL_EMAIL_APPROVAL_SUCCESS";
export const ADMIN_MANUAL_EMAIL_APPROVAL_ERROR =
  "ADMIN_MANUAL_EMAIL_APPROVAL_ERROR";

export const GET_APPREG_STATUS = "GET_APPREG_STATUS";
export const GET_APPREG_STATUS_SUCCESS = "GET_APPREG_STATUS_SUCCESS";
export const GET_APPREG_STATUS_ERROR = "GET_APPREG_STATUS_ERROR";

export function resetCreateUserStatus() {
  return (dispatch: Dispatch) => {
    dispatch({
      type: ADMIN_RESET_USER_STATUS,
    });
  };
}

export function adminCreateUser(contact: unknown) {
  return (dispatch: Dispatch) => {
    dispatch({
      type: ADMIN_CREATE_USER,
      payload: {
        data: contact,
      },
    });
  };
}

export function updateManualEmailApproval(manualEmailApproval: unknown) {
  return (dispatch: Dispatch) => {
    dispatch({
      type: ADMIN_MANUAL_EMAIL_APPROVAL,
      payload: {
        data: {
          manualEmailApproval,
        },
      },
    });
  };
}

export function ticketNoteStoreTemp(ticketNote: unknown) {
  return (dispatch: Dispatch) => {
    dispatch({
      type: ADD_TICKET_NOTE_TEMP,
      payload: {
        data: ticketNote,
      },
    });
  };
}
